<template>
  <div id="app">
    <router-view @myTheme="darkModeFunc"/>
  </div>
</template>

<style lang="scss">
 @import "@/assets/scss/custom.scss";
</style>
<script>

export default {
  name: 'home',
  data: function () {
    return {
      darkModeApp: true
    }
  },
  created () {
    this.$router.beforeEach((to, from, next) => {
      this.deleteServiceWorkers()
      if (localStorage.getItem('token') || to.name === 'login') { next() } else {
        console.log('sin token')
        this.$router.push({ name: 'login' })
      }
    })
  },
  methods: {
    darkModeFunc: function () {
      var body = document.body
      this.darkModeApp = !this.darkModeApp
      if (this.darkModeApp) {
        body.classList.add('dark-mode')
      } else {
        body.classList.remove('dark-mode')
      }
    },
    deleteServiceWorkers () {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          for (let registration of registrations) {
            registration.unregister()
          }
        })
      }
    }
  }
}
</script>
